import "../../css/FullEvent/FullEvent.css";
import "../../css/GlobalStyles.css";
import { memo } from "react";
import { Event, AccountData } from "@markit/common.types";
import { isDesktop } from "react-device-detect";
import FullEventTimeCard from "./FullEventTimeCard";
import { useTheme } from "../../hooks/useTheme";
import OrganizersInfoDisplay from "../FullEventSubComponents/OrganizersInfoDisplay";
import { FullEventLocationPin } from "./FullEventLocationPin";

type FullEventHeaderProps = {
  event: Event;
  host: AccountData | undefined;
  address: string;
  cohostsList?: AccountData[];
};

const FullEventHeader = memo(function FullEventHeaderFn(
  props: FullEventHeaderProps
) {
  const { event, host, address, cohostsList } = props;
  const { theme } = useTheme();

  return (
    <div className="ColumnNormal" style={{ gap: 20 }}>
      <div className="ColumnNormal" style={{ gap: 10 }}>
        <span style={{ ...theme.PrimaryText, fontSize: 36, fontWeight: 500 }}>
          {event.title}
        </span>
        {!isDesktop && host ? (
          <OrganizersInfoDisplay
            host={host}
            organizers={cohostsList ? [host, ...cohostsList] : [host]}
            hideContactBanner
          />
        ) : null}
      </div>
      <div className="ColumnNormal" style={{ gap: 14 }}>
        <div className="AlignedRow">
          <FullEventTimeCard event={event} />
        </div>
        <FullEventLocationPin event={event} address={address} showCondensed />
      </div>
    </div>
  );
});

export default FullEventHeader;
